import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useMembersMutations from "../../datahooks/useMembersMutations";

interface ResendInviteProps {
  inviteToken: string;
  onClose: () => void;
  onBack: () => void;
}

export default function ResendInvite({
  inviteToken,
  onClose,
  onBack,
}: ResendInviteProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { resendInvite, isResendingInvite } = useMembersMutations();

  function onResendInvite() {
    resendInvite({ inviteToken }).then(onClose);
  }
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Header
        title="Resend invite?"
        subtitle="This user will receive an invitation email"
      />

      <Footer className="items-center justify-end">
        <Button
          variant="secondary-black"
          disabled={isResendingInvite}
          onClick={onBack}
        >
          Cancel
        </Button>

        <Button isLoading={isResendingInvite} onClick={onResendInvite}>
          Resend invite
        </Button>
      </Footer>
    </>
  );
}
